document.addEventListener('DOMContentLoaded', () => {
  let typedText = '';

  function getWistiaCode(respContainer) {
    const child = respContainer?.querySelector(':scope > [id^="wistia_"]');
    return child?.id.replace(/^wistia_/, '') || null;
  }

  document.addEventListener('keydown', (event) => {
    if (event.key.length === 1) {
      typedText += event.key.toLowerCase();
    }

    if (typedText.length > 50) {
      typedText = typedText.slice(-50);
    }

    if (typedText.includes('showtrailer')) {
      const respContainer = document.querySelector('.kjb-video-responsive');
      const wistiaCode = getWistiaCode(respContainer);

      if (wistiaCode) {
        alert(`Id Trailer: ${wistiaCode}`);
      } else {
        alert('Code not found');
      }

      typedText = '';
    }
  });
});

//push to dataLayer
(async function () {
  try {
    const currentRoute = window.location.pathname;
    const response = await fetch(
      `https://dmc-central-database-356018239005.europe-west3.run.app/catalogue-data?route=${encodeURIComponent(currentRoute)}`,
    );
    if (!response.ok) throw new Error('Error obtaining data for catalogue');
    const data = await response.json();
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'view_item',
      page_type: 'class_detail',
      ecommerce: {
        items: [
          {
            item_id: data.id,
            item_name: data.title,
            item_brand: data.brand,
            item_category: data.tags || '',
            quantity: 1,
          },
        ],
      },
    });
    console.log('item catalogue added');
  } catch (error) {
    console.error('Error adding to ecommerce:', error);
  }
})();
